// eslint-disable-next-line no-shadow
export enum JobTypes {
    PotreeConvert = 'potreeConvert',
    CompressedFiles = 'compressedFiles',
}
